const { isEmpty } = require("lodash");
const { SingleSelectPrototype } = require("./prototypes");

function RadioButtonType() {
  this.type = "radiobutton";

  this.validate = ({ eligibility, answer }) => {
    const answerObj = typeof answer === "string" ? JSON.parse(answer) : answer;
    const answers = Object.keys(answerObj || {}).filter((k) => answerObj[k]);
    return isEmpty(eligibility) || eligibility.some((v) => answers.includes(v));
  };
}
RadioButtonType.prototype = SingleSelectPrototype;

module.exports = RadioButtonType;
